import { useNavigate, useParams } from "react-router-dom";
import Api from "../../services/ApiService"
import { useEffect, useState } from "react";
import { useAuthDispatch, useAuthState } from "../../context/AuthContext";
import { Button, Col, FloatingLabel, Form, ListGroup, ListGroupItem, Row, Spinner } from "react-bootstrap";
import { useQueryClient } from "react-query";

/**
 * LoginComponent
 * 
 * Used in Homepage > ActionSide 
 * 
 * 
 * @param {Function} changeView
 * @param {Object} qrData
 * @param {Function} showInfoVideo
 * @returns 
 */
const LoginComponent = ({changeView, qrData, showInfoVideo}) => {

    const API = new Api();
    const dispatch = useAuthDispatch();
    const {authenticated, user} = useAuthState();
    const { next } = useParams();
    const navigate = useNavigate();
    const queryClient = useQueryClient();

    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [loginLoading, setLoginLoading] = useState(false);
    const [loginErrorVisible, setLoginErrorVisible] = useState(false);
    const [loginError, setLoginError] = useState("");

    const toPasswordComponent = (e) => {
        e.preventDefault();
        changeView("password");
    }

    useEffect(() => {
        if (authenticated === true && next === undefined) {
            queryClient.clear();
            if (user !== null) {
                if (user.x_is_house_management) {
                    if (qrData) {
                        navigate(`/hw/dashboard/gebaeude/anlagen/${qrData.top.x_gebaeude_id[0]}/${qrData.anlage[0].x_studio_field_mWMGR}`)
                    } else {
                        navigate('/hw/dashboard/');
                    }
                }
                else navigate('/dashboard/');
            }
        }
    },[next, authenticated])



    const submitHandler = (e) => {
        e.preventDefault();
        setLoginLoading(true);
        setLoginErrorVisible(false);

        API.login(email, password)
            .then(res => {
                localStorage.setItem('token', JSON.stringify(res.data));
                setLoginLoading(false);
                let db_user = res.data.partner;
                dispatch('LOGIN', db_user);
                delete res.data['partner'];
                let url = "";
                if (db_user.x_is_house_management) {
                    if (qrData) {
                        url = `/hw/dashboard/gebaeude/anlagen/${qrData.top.x_gebaeude_id[0]}/${qrData.anlage.id}`
                    }
                    url = "/hw/dashboard/";
                }
                else url = "/dashboard/";
                if (next) {
                    url = next.replaceAll("_", "/");
                }
                navigate(url);
            })
            .catch(err => {
                setLoginLoading(false);
                if (err.response.data.detail !== undefined) setLoginError(err.response.data.detail);
                else setLoginError("Unbekannter Fehler, veruschen Sie später noch mal.")
                setLoginErrorVisible(true);
            });
    }

    return (
        <div className="actions-section-content">
            <h3 className="text-light"><span className="text-dark title-energo">ENERGO </span>Managementportal</h3>
            {qrData &&
                <p className="text-dark">
                    Sie befinden sich in Top {qrData.top.x_topnummer}, {qrData.top.x_gebaeude_address_street}
                </p>
            }
            <Row className="mt-3 animate-slide-left">
                <Form onSubmit={e => submitHandler(e)}>
                    <Form.Group className="mb-3" controlId="username">
                        <FloatingLabel label="E-Mail">
                            <Form.Control
                                name="email"
                                autoComplete="email"
                                type="email"
                                placeholder="E-Mail"
                                value={email}
                                onChange={e => setEmail(e.target.value)}
                                required
                            />
                        </FloatingLabel>
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="password">
                        <FloatingLabel label="Passwort">
                            <Form.Control
                                name="password"
                                autoComplete="password"
                                type="password"
                                placeholder="Passwort"
                                value={password}
                                onChange={e => setPassword(e.target.value)}
                                required
                            />
                        </FloatingLabel>
                        <Form.Text className="text-danger" hidden={!loginErrorVisible}>
                            <b>{loginError}</b>
                        </Form.Text>
                    </Form.Group>
                    <Col className="mb-4 text-end">
                        <a onClick={e => toPasswordComponent(e)} href="password/vergessen/" className="link-energo text-light">
                            Passwort anfordern / vergessen?
                        </a>
                    </Col>
                    <Col xs="12" className="text-center">
                        {
                            loginLoading ? 
                                <Spinner animation="border" variant="warning" /> :
                                <Button variant="warning" type="submit">Anmelden</Button>
                        }
                    </Col>
                </Form>
            </Row>
            <Row className="mt-5">
                <ListGroup variant="flush" className="text-center ">
                    <ListGroupItem action onClick={() => changeView("register")} style={{background: "transparent", color: "white"}}>
                        Kunde werden / Angebot einholen
                    </ListGroupItem>
                    <ListGroupItem action onClick={() => showInfoVideo()} style={{background: "transparent", color: "white"}}>
                        Vorstellungsvideo anzeigen
                    </ListGroupItem>
                </ListGroup>
            </Row>
            {qrData && qrData.hw.image_1920 &&
                <Row className="mt-5 justify-content-center">
                    <Col xs="12" className="text-center">
                        {
                            qrData.hw.image_1920 !== "False" && qrData.hw.image_1920 !== null ?
                                <img 
                                    src={`data:image/jpg;base64,${qrData.hw.image_1920}`} 
                                    alt=""
                                /> :
                                <h4>{qrData && qrData.top.x_houseverwaltung_id}</h4>
                        }
                        </Col>
                </Row>
            }
        </div>
    )
}
export default LoginComponent;